import React, { Component } from 'react';
import { QueryRenderer, graphql } from 'react-relay';
import environment from '../../data/environment';
import { FormattedHTMLMessage } from 'react-intl';
import ReportWrapper from './components/ReportWrapper';
import CenteredErrorMessage from '../../components/CenteredErrorMessage';
import CenteredLoadingAnimation from '../../components/CenteredLoadingAnimation';

class Report extends Component {
  render() {
    const routeParams = this.props.match.params;
    return (
      <QueryRenderer
        environment={environment}
        query={graphql`
          query ReportQuery($reportId: ID!) {
            viewer {
              ...ReportWrapper_viewer
            }
            report(id: $reportId) {
              ...ReportWrapper_report
            }
            devices(showDeleted: true) {
              ...ReportWrapper_devices
            }
            surveys {
              ...ReportWrapper_surveys
            }
            reports {
              ...ReportWrapper_reports
            }
          }
        `}
        variables={{
          reportId: routeParams.reportId,
        }}
        render={({ error, props }) => {

          if (error) {
            console.error(error);

            return (
              <CenteredErrorMessage>
                <FormattedHTMLMessage id="error.couldNotFetch" />
                <br /><hr /><div>{error.message}</div>
                <br /><div>{error.stack}</div>

              </CenteredErrorMessage>
            );
          } else if (props) {
            return (
              <ReportWrapper
                viewer={props.viewer}
                report={props.report}
                reports={props.reports}
                devices={props.devices}
                surveys={props.surveys}
              />
            );
          } else {
            return <CenteredLoadingAnimation />;
          }
        }}
      />
    )
  }
}

export default Report;





// WEBPACK FOOTER //
// ./src/scenes/Report/Report.js